import React from 'react'
import MenuItems from '../MenuItems/MenuItems'
import './Menu.scss'

const Menu = () => {
    return <div className="menu">
              <MenuItems />
            </div>
}
export default Menu;